import { Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { MonacoType } from '../../../../../../../../types/global.d';
import { defaultEditorOptions, defaultTheme, lightTheme } from './common';

type FormulaEditorProps = {
  value: string;
  language: string; // ******* TODO chris make this a string literal and tie into apps/dashboard/source/packages/creditAgreements/ui/CreditAgreementFullArtifact/edit/MonacoEditor/hooks/useSetupMonacoEditor.tsx
  width?: string;
  resize?: 'both' | 'vertical';
  height?: string;
  onChange: (
    value: string | undefined,
    ev: MonacoType.editor.IModelContentChangedEvent,
  ) => void;
  onValidate?: (markers: MonacoType.editor.IMarker[]) => void;
  operationMode?: CreditAgreement.OperationMode;
};
export const FormulaEditor = ({
  value,
  language,
  width = '100%',
  resize = 'both',
  height = '15vh',
  onChange,
  onValidate,
  operationMode = 'admin',
}: FormulaEditorProps) => {
  const theme = operationMode === 'client' ? lightTheme : defaultTheme;
  return (
    <Flex
      width={width}
      resize={resize}
      height={height}
      minHeight={height}
      overflow="auto"
    >
      <Editor
        language={language}
        onChange={onChange}
        onValidate={onValidate}
        options={defaultEditorOptions}
        theme={theme}
        value={value}
      />
    </Flex>
  );
};
